/* eslint-disable */
export default {
  tollFree: 'Gebührenfrei',
  rcvPmiMeetingTitle: 'Videobesprechung von {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
